import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import api from '@/api';
        Vue.use(Router);
// Vue.use(store);

        const router = new Router({
        mode: 'history',
                linkActiveClass: 'active',
                base: process.env.BASE_URL,
                routes: [
////////
                    {path: '/html/basket',component: () => import('@/views2/Basket.vue'),},
                    {path: '/html/closed',component: () => import('@/views2/Closed.vue'),},
                    {path: '/html/index',component: () => import('@/views2/Index.vue'),},
                    {path: '/html/login',component: () => import('@/views2/Login.vue'),},
                    {path: '/html/pay',component: () => import('@/views2/Pay.vue'),},
                    {path: '/html/registration',component: () => import('@/views2/Registration.vue'),},
                    {path: '/html/start',component: () => import('@/views2/Start.vue'),},
                    {path: '/html/success',component: () => import('@/views2/Success.vue'),},
////////
                {
                path: '/',
                        component: () => import('@/views/Index.vue'),
                },
                {
                name: '/utils/',
                        path: '/utils',
                        component: () => import('@/views/Utils.vue'),
                },
                {
                path: '/login',
                        component: () => import('@/views/Login.vue'),
                },
                {
                name: '/registration',
                        path: '/registration',
                        component: () => import('@/views/Registration.vue'),
                },
                {
                path: '/basket',
                        component: () => import('@/views/Basket.vue'),
                },
                {
                name: '/start',
                        path: '/start',
                        component: () => import('@/views/Start.vue'),
                },
                {
                path: '/pay',
                        component: () => import('@/views/Pay.vue'),
                },
                {
                name: '/success',
                        path: '/success',
                        component: () => import('@/views/Success.vue'),
                },
                {

                name: '/fail',
                        path: '/fail',
                        component: () => import('@/views/Fail.vue'),
                },
                {
                name: '/reciept',
                        path: '/reciept',
                        component: () => import('@/views/Reciept.vue'),
                },
                {
                name: '/closed',
                        path: '/closed',
                        component: () => import('@/views/Closed.vue'),
                },
                {
                path: '*',
                        redirect: '/',
                },
                ],
        });
export default router;
